export const environment = {
  url: {
    api: `https://apim-uat.houseofhr.com/square-app-accent/api/v2.0`,
  },
  production: true,
  ocpApimSubscriptionKey: 'bc20545ff4ec40b7856a2ec2dba33431'
};

